import React from "react";
import { PHONE } from "../../utils/helpers";
import Form from "../Form";
import "./style.scss";
const ContactArea = ({ className }) => {
  return (
    <div className={className}>
      <div className="container">
        <div className="row">
          <div className="col-lg-5 col-12">
            <div className="contactInfo">
              <span>For Our Honorabe Clients</span>
              <h2>Free Consulting</h2>
              <h6>
                Call us 24/7 at {PHONE} or fill out the form to get in touch.
              </h6>
              <p></p>
            </div>
          </div>
          <div className="col-12 col-lg-7">
            <Form />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ContactArea;
